export default "__VITE_ASSET__BJqPdalH__"